import { nl } from './nl';

type Primitive = string | number | boolean;

function getByPath(obj: unknown, path: string): unknown {
  return path.split('.').reduce<unknown>((acc, key) => {
    if (acc && typeof acc === 'object' && key in (acc as Record<string, unknown>)) {
      return (acc as Record<string, unknown>)[key];
    }
    return undefined;
  }, obj);
}

function interpolate(template: string, vars?: Record<string, Primitive>): string {
  if (!vars) return template;
  return template.replace(/\{\{(\w+)\}\}/g, (match, key: string) => {
    const value = vars[key];
    return value === undefined ? match : String(value);
  });
}

/**
 * Dot-path lookup translator, e.g. t('editor.topbar.undo').
 * Falls back to the raw key (visibly) if a string is missing so gaps are
 * obvious during development instead of silently rendering nothing.
 */
export function t(path: string, vars?: Record<string, Primitive>): string {
  const value = getByPath(nl, path);
  if (typeof value === 'string') {
    return interpolate(value, vars);
  }
  return `[[${path}]]`;
}

export function tPlural(count: number, singularPath: string, pluralPath: string): string {
  return count === 1 ? t(singularPath) : t(pluralPath, { count });
}

export { nl };
